export default "__VITE_ASSET__BFl1ryki__"